import { cachedGet } from './metricsCache';

// `?tag_ids[]=..&plan_types[]=..` (or '').
const buildQuery = (tagIds = [], planTypes = []) => {
  const parts = [];
  (Array.isArray(tagIds) ? tagIds : []).forEach((id) => parts.push(`tag_ids[]=${encodeURIComponent(id)}`));
  (Array.isArray(planTypes) ? planTypes : []).forEach((p) => parts.push(`plan_types[]=${encodeURIComponent(p)}`));
  return parts.length ? '?' + parts.join('&') : '';
};

// Request paths = cache keys. Built here so the per-widget fetches and the batch
// loader produce identical strings (the batch must prime what a widget asks for).
export const metricsPaths = {
  urlCountByStatus: (tagIds = [], planTypes = []) =>
    `metrics/url_count_by_status${buildQuery(tagIds, planTypes)}`,
  incidentCountByDay: (start, end, tagIds = [], planTypes = []) =>
    `metrics/incident_count_by_day/${start}/${end}${buildQuery(tagIds, planTypes)}`,
  incidentCountByUrl: (start, end, tagIds = [], planTypes = []) =>
    `metrics/incident_count_by_url/${start}/${end}${buildQuery(tagIds, planTypes)}`,
  incidentCountBySeverity: (start, end, tagIds = [], planTypes = []) =>
    `metrics/incident_count_by_severity/${start}/${end}${buildQuery(tagIds, planTypes)}`,
  incidentCountByDaySeverity: (start, end, tagIds = [], planTypes = []) =>
    `metrics/incident_count_by_day_severity/${start}/${end}${buildQuery(tagIds, planTypes)}`,
  incidentCountByUrlSeverity: (start, end, tagIds = [], planTypes = [], levels = []) => {
    let query = buildQuery(tagIds, planTypes);
    (Array.isArray(levels) ? levels : []).forEach((lvl) => {
      query += (query ? '&' : '?') + `levels[]=${encodeURIComponent(lvl)}`;
    });
    return `metrics/incident_count_by_url_severity/${start}/${end}${query}`;
  },
  planUtilisation: () => 'metrics/plan_utilisation',
  incidentCountByFqdnTag: (start, end) => `metrics/incident_count_by_fqdn_tag/${start}/${end}`,
  blackoutCoverage: (tagIds = [], planTypes = []) =>
    `metrics/blackout_coverage${buildQuery(tagIds, planTypes)}`,
  // Not metrics/* aggregates: these reuse module endpoints and reduce client-side,
  // so they are cached but never batch-primed.
  crawlSchedules: () => 'firecrawl/schedules',
  domainCrawlSchedules: () => 'domain_crawl_schedules',
  archivedUrlCount: (tagIds = []) =>
    `urls?archived=true&page=1&items_per_page=1${buildQuery(tagIds).replace('?', '&')}`
};

const HomeService = {
  fetchCountsNumberOfURLsByHealthStatus: async (tagIds = [], planTypes = []) => {
    return cachedGet(metricsPaths.urlCountByStatus(tagIds, planTypes));
  },
  fetchCountsNumberOfIncidentsPerDay: async (start, end, tagIds = [], planTypes = []) => {
    return cachedGet(metricsPaths.incidentCountByDay(start, end, tagIds, planTypes));
  },
  fetchCountsNumberOfIncidentsPerUrl: async (start, end, tagIds = [], planTypes = []) => {
    return cachedGet(metricsPaths.incidentCountByUrl(start, end, tagIds, planTypes));
  },
  fetchIncidentCountBySeverity: async (start, end, tagIds = [], planTypes = []) => {
    return cachedGet(metricsPaths.incidentCountBySeverity(start, end, tagIds, planTypes));
  },
  fetchIncidentCountByDaySeverity: async (start, end, tagIds = [], planTypes = []) => {
    return cachedGet(metricsPaths.incidentCountByDaySeverity(start, end, tagIds, planTypes));
  },
  fetchIncidentCountByUrlSeverity: async (start, end, tagIds = [], planTypes = [], levels = []) => {
    return cachedGet(metricsPaths.incidentCountByUrlSeverity(start, end, tagIds, planTypes, levels));
  },
  fetchPlanUtilisation: async () => {
    return cachedGet(metricsPaths.planUtilisation());
  },
  fetchIncidentCountByFqdnTag: async (start, end) => {
    return cachedGet(metricsPaths.incidentCountByFqdnTag(start, end));
  },
  fetchBlackoutCoverage: async (tagIds = [], planTypes = []) => {
    return cachedGet(metricsPaths.blackoutCoverage(tagIds, planTypes));
  },
  fetchCrawlSchedules: async () => {
    return cachedGet(metricsPaths.crawlSchedules());
  },
  fetchDomainCrawlSchedules: async () => {
    return cachedGet(metricsPaths.domainCrawlSchedules());
  },
  fetchArchivedUrlCount: async (tagIds = []) => {
    return cachedGet(metricsPaths.archivedUrlCount(tagIds));
  }
};

export default HomeService;
